import React from 'react';
import { clsx } from 'clsx';
import { LineHeight } from '@common/tokens';

export const AccountItem = (props: {
  mode?: 'appbar';
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) => {
  const children = React.Children.toArray(props.children);
  const [leading, content, action] = children;

  return (
    <div
      onClick={props.onClick}
      className={clsx(
        'account-item',
        props.mode !== 'appbar' && 'in-menu',
        props.className
      )}
    >
      <div className="leading">{leading}</div>
      <div className="contents">{content}</div>
      {!!action && <div className="action">{action}</div>}
      <style jsx>
        {`
          .account-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
          }
          .account-item.in-menu {
            width: 100%;
            min-width: 300px;
            padding: 8px;
          }
          .account-item.in-menu .contents {
            padding-left: 12px;
          }
          .account-item .contents {
            display: flex;
            flex: 1;
            flex-direction: column;
            padding-left: 4px;
            line-height: ${LineHeight.sm};
          }
        `}
      </style>
    </div>
  );
};
